/* eslint-disable */
// import axios from "axios";
import router from '@/router';
import { AppUrl, user_api as axios } from "@/assets/js/variables";
import * as help from "@/helpers/functions.js"
import JwtService from "../../assets/js/JwtService";

const state = {

  selected_product: {
    id: 0,
    specs: [
      {product_domains: []},
    ],
    status: null,
  },
  selected_urls_of_product: [],
  showConflict: false,
  /////////////////////
  products_ids_with_conflict: [],// array with products id
  valid_domains_urls: [],
  invalid_domains_urls: [],
  fetched_products_info: [],
  //////////
  conflict_temporary_urls: {
    valid: [],
    invalid: [],
  },
  ///// conflict final table
  conflict_temporary_data: {},
  /////////////////////
  product_filter: {
    selected_client: '0',
    product_status: "active",
    selected_status: null,
    selected_sellers: [],
    selected_domains: [],
    brand: '',
    category: '',
    name: '',
    sku: '',
    ean: '',
    product_type: 'exact',
  },
  loaded_products: [] ,
  clients_list: [{ value: "0", text: "No client" }],
  inactive_clients: [{ value: "0", text: "No client" }],
  sellers: [] ,
  domains: [] ,
  variations: [],
  translations: [],
  loading: false,
  lists: [],
  sync_status: [],
  variationSuccessSnackbar: false,
  variationErrorSnackbar: false
};

const getters = {
  selected_product_clients_names(state) {
    return (state.selected_product.specs.product_clients)
    ? state.selected_product.specs.product_clients
        .map((client) => client.client_name)
    : [];
  },
  selected_product_clients_ids(state) {
    return (state.selected_product.specs.product_clients)
    ? state.selected_product.specs.product_clients
        .map( (client) => client.client_id )
    : [];
  },
  // selected_client_name ( state ) {
  //   return state.clients_list.find(x => x.value == state.product_filter.selected_client).text;
  // },
  selected_client_name: (state) => {
    return state.clients_list.find(x => x.value == state.product_filter.selected_client).text;
  },
  // selected_product_item ( state ) {
  //   return state.loaded_products.find(x => x.product_id === state.selected_product.id);
  // },
  // show_selected_product_table ( state ) {
  //   return state.loaded_products
  //           .map((product) => (product.product_id))
  //           .includes( this.$store.state.productionModule.selected_product.id )
  // },
  // show_selected_product_test ( state ) {
  //   return state.selected_product.id;
  // },
  show_selected_product_table ( state ) {
    // return this.$store.getters.show_selected_product_test;
    return (!state.loaded_products.length)
            ? false
            : state.loaded_products.map( product => product.product_id ).includes( state.selected_product.id )
  },
  new_valids_domains_urls ( state ) {
    let first_level_domain_urls = [];
    state.valid_domains_urls.forEach(domain => {
      domain.domain_urls.forEach(url => {
        if(url.url_id < 0){
          first_level_domain_urls.push({
            domain_id: domain.domain_id,
            domain_name: domain.domain_name,
            url_id: url.url_id,
            url: url.url,
            variation: url.variation,
            sellers: url.sellers,
          })
        }
      })
    });
    return first_level_domain_urls;
  }
};

const mutations = {
  CATCH_BY_STATUS ( state, status_code ) {
    console.log('error_code: ', status_code )
    if (status_code>=400 && status_code < 500){
      this.commit('RESET_PRODUCTION');
      this.commit('authModule/logout', 'authModule', { root: true });
      router.push('login');
    }
  },
  RESET_PRODUCTION ( state ) {
    // state.selected_product = {
    //   id : 0,
    //   specs: [],
    // } ;
    // state.selected_urls_of_product = [] ;
    state.showConflict = false ;
    state.products_ids_with_conflict = [] ;// array with products id
    state.valid_domains_urls = [] ;
    state.invalid_domains_urls = [] ;
    state.fetched_products_info = [] ;
    state.conflict_temporary_urls  = {
      valid: [],
      invalid: [],
    } ;
    state.conflict_temporary_data = {} ;
    // state.product_filter = {
    //   selected_client: '0',
    //   product_status: "active",
    //   selected_sellers: [],
    //   selected_domains: [],
    //   brand: '',
    //   category: '',
    //   name: '',
    //   sku: '',
    //   ean: '',
    // } ;
    // state.loaded_products = [] ;
  },
  SET_PRODUCTION_STATE( state, {key, value} ) {
    console.log(`SET_PRODUCTION_STATE, productionModule/state.${key} :`, value )
    state[key] = value;
  },
  SET_SELECTED_PRODUCT (state, product_obj ) {
    // product_obj = { key: '', value }
    console.log(`productionModule/ state.selected_product.${product_obj.key} :`, product_obj.value )
    // make sure variation ids are numbers
    if (product_obj.value.product_domains) {
      for (let domain of product_obj.value.product_domains) {
        for (let url of domain.domain_urls) {
          for (let seller of url.sellers) {
            seller.variation_id = +seller.variation_id;
          }
        }
      }
    }
    state.selected_product[product_obj.key] = product_obj.value;
  },
  // SET_CLIENTS( state, data ) {
  //   state.clients_list = data.filter(x => x.active);
  // },
  SET_SELECTED_CLIENT( state, value ) {
    state.product_filter.selected_client = value
  },
  RESET_SPECS_OF_SELECTED_ITEM ( state ) {
    if(!!state.selected_product.specs){
      state.selected_product.specs = {product_domains: []};
      state.selected_product.status = null;
    }
  },
  SET_PRODUCT_STATUS( state, value ) {
    state.product_filter.product_status = value;
  },
  SET_PRODUCT_CREATED_AT (state, value) {
    state.selected_product.specs.product_info.created_at.date = value;
    const index = state.loaded_products.findIndex(p => p.product_id === state.selected_product.id)
    if(index >= 0){
      const parts = value.split('-') // split the YYYY-mm-dd
      state.loaded_products[index].created_at = `${parts[2]}/${parts[1]}/${parts[0]}`; // merge to dd/mm/YYYY
    }
  },
  SET_SELECTED_STATUS(state, value) {
    state.product_filter.selected_status = value;
  },
  SET_SELECTED_PRODUCT_TYPE(state, value) {
    state.product_filter.product_type = value;
  },
  SET_SELECTED_LIST(state, value) {
    // state.product_filter = Object.assign(state.product_filter, { list: value });
    state.product_filter.list = value;
  },
  SET_DATES(state, value) {
    state.product_filter.dates = value;
  },
  SET_SELLERS( state, value ) {
    state.sellers = value
  },
  SET_DOMAINS( state, value ) {
    state.domains = value
  },
  SET_SELECTED_SELLERS( state, value ) {
    state.product_filter.selected_sellers = value
  },
  SET_SELECTED_DOMAINS( state, value ) {
    state.product_filter.selected_domains = value
  },
  SET_PRODUCT_FILTER( state, obj ) {
    console.log('product filter key', obj.key )
    console.log('product filter key 2', state.product_filter[obj.key] )
    state.product_filter[obj.key] = obj.value;
  },
  REMOVE_PRODUCT( state, product_index ) {
    state.loaded_products.splice(product_index, 1)
  },
  REMOVE_DOMAIN_FROM_PRODUCT_DOMAINS ( state, deleted_id ) {
    state.selected_product.specs.product_domains = state.selected_product.specs.product_domains.filter( x => x.domain_id != deleted_id ) ;
  },
  CONCAT_PRODUCTS ( state, products ) {
    state.fetched_products_info.concat(products);
  },
  PUSH_PRODUCTION_STATE ( state, product_domains ) {
    state[product_domains.key].push(...product_domains.value);
  },
  RESET_PRODUCT_CONFLICT ( state, product_id ) {
    state.products_ids_with_conflict = state.products_ids_with_conflict.filter( x => x != product_id );
    state.valid_domains_urls = state.valid_domains_urls.filter( x => x.product_id != product_id );
    state.invalid_domains_urls = state.invalid_domains_urls.filter( x => x.product_id != product_id );
  },
  REMOVE_VALID_DOMAIN_URLS( state, item ) {
    const domain_index = state.valid_domains_urls.findIndex(x => x.domain_id == item.domain_id ); //empty from domain_urls
    state.valid_domains_urls[domain_index].domain_urls = state.valid_domains_urls[domain_index].domain_urls.filter(x => x.url_id != item.url_id);
    if(!state.valid_domains_urls[domain_index].domain_urls.length){// empty the domain
      state.valid_domains_urls.splice(domain_index, 1);
    }
    // removing from valid_domains_urls also removed from conflict_temporary_urls.valid because these arrays are primitive type
  },
  DELETE_URLS( state, item ) {
    const domain_index = state.selected_product.specs.product_domains.findIndex(x => x.domain_id == item.domain_id ); //empty from domain_urls
    state.selected_product.specs.product_domains[domain_index].domain_urls = state.selected_product.specs.product_domains[domain_index].domain_urls.filter(x => x.url_id != item.url_id);
    if(!state.selected_product.specs.product_domains[domain_index].domain_urls.length){// empty the domain
      state.selected_product.specs.product_domains.splice(domain_index, 1);
    }
  },
  UPD_NEW_URL (state , item) {
    console.log('item', item)
    const url = state.selected_product.specs.product_domains
      .find(dom => dom.domain_id === item.domain_id).domain_urls
      .find(u => u.url_id === item.url_id)
    url.url = item.url;

    url.sellers.forEach(seller => {
      const sku = seller.urls_properties.find(sku => sku.property_id === 4) ;
      if(sku !== undefined){
        sku.property_value = item.sku;
      } else {
        seller.urls_properties.push({property_id: 4, property_value: item.sku, renewed: ''})
      }
      const ean = seller.urls_properties.find(ean => ean.property_id === 7);
      if (ean !== undefined) {
        ean.property_value = item.ean;
      } else {
        seller.urls_properties.push({ property_id: 7, property_value: item.ean, renewed: '' })
      }
      const mpn = seller.urls_properties.find(mpn => mpn.property_id === 20);
      if (mpn !== undefined) {
        mpn.property_value = item.mpn;
      } else {
        seller.urls_properties.push({ property_id: 20, property_value: item.mpn, renewed: '' })
      }
    });
  },
  SET_PENDING_PRODUCT_CLIENTS (state, clients) {
    console.log('clients must be array of {value,text}. clients:', clients);
    state.selected_product.specs.product_clients = clients.map((c) => ({
      client_id: c.value,
      client_name: c.text,
    }));
  },
  SET_CONFLICT_PRODUCT_CLIENTS (state, clients) {
    console.log('clients must be array of names. clients:', clients);
    state.conflict_temporary_data.clients_conflict = clients
  },
  RESET_VALIDS_AND_CONFLICTS(state) {
    state.showConflict = false;
    state.products_ids_with_conflict = [];// array with products id
    state.valid_domains_urls = [];
    state.invalid_domains_urls = [];
    state.fetched_products_info = [];
    state.conflict_temporary_urls = {
      valid: [],
      invalid: [],
    };
    state.conflict_temporary_data = {};
  },
  SAVE_CONFLICT_FOR_NEW_PRODUCT(state, { conflict_product_id, pendings }) {
    let extracted_domain = help.exractProductDomains(state.invalid_domains_urls);
    extracted_domain = extracted_domain.filter(x => x.product_id != conflict_product_id);
    state.invalid_domains_urls = help.compressToProductDomains(extracted_domain);
    state.valid_domains_urls.push(...pendings.filter(x => !state.valid_domains_urls.map(y => y.url_id).includes(x.url_id)));
  },
  SET_SELECTED_PRODUCT_STATUS(state, value){
    console.log('product status value', value)
    state.selected_product.status = value;
    try {
      const index = state.loaded_products.findIndex(p => p.product_id === state.selected_product.id)
      state.loaded_products[index].status = value
    } catch (error) {
      console.log(error)
    }
  },
  UPDATE_LOADED_PRODUCTS_STATUS(state, {id, status}){
    console.log('test', { id, status })
    state.loaded_products.find(p => p.product_id === id).status = status;
  },
  UPDATE_SELECTED_PRODUCT(state, {id, brand, name, type}) {
    if(state.selected_product.id != id) throw new Error('not same product id')
    state.selected_product.specs.product_info.product_name = name;
    state.selected_product.specs.product_info.product_brand = brand;
    state.selected_product.specs.product_info.product_type = type;
    const that_product = state.loaded_products.find(p => p.product_id == id)
    that_product.product_name = name
    that_product.brand = brand
  },
  SET_product_requested_at( state, date ) {
    state.selected_product.specs.product_info.requested_at.date = date
  },
  SET_SELLER_VARIATION(state, data) {
    console.log('got into test - ' + data.track_id + ',' + data.variation_id)
    for (let domain of state.selected_product.specs.product_domains) {
      for (let url of domain.domain_urls) {
        for (let seller of url.sellers) {
          if (seller.track_id == data.track_id) {
            seller.variation_id = data.variation_id;
          }
        }
      }
    }
  },
  SET_variationSuccessSnackbar(state, data) {
    state.variationSuccessSnackbar = data;
  },
  SET_variationErrorSnackbar(state, data) {
    state.variationErrorSnackbar = data;
  },
};

const actions = {

  general_api({ commit }, payload) {
    const params = { headers: { Authorization: `Bearer ${JwtService.getToken()}` }}
    return new Promise((resolve, reject) => {
      axios
        .post(AppUrl, payload, params)
        .then(function (response) {
          console.log(`action - ${payload.task}: `, response.data);
          // if (response.data.status === 'Error') reject(response.data);
          resolve(response);
        })
        .catch((err) => commit('CATCH_BY_STATUS', err.response.status));
    });
  },

  ADD_URL_ON_PRODUCT( { state }, payload ) {
    const params = { headers: { Authorization: `Bearer ${JwtService.getToken()}` } }
    const data = {
      raw_links: {
        productInfo: {
          state: "addition",
          product_id: state.selected_product.id,
        },
        urlInfo: payload,
      }
    }
    return new Promise((resolve, reject) => {
      axios
        .post(AppUrl, data, params)
        .then(function (response) {
          // console.log(`action - ${payload.task}: `, response.data);
          resolve(response);
        })
        .catch((err) => commit('CATCH_BY_STATUS', err.response.status));
    });
  },

  RESOLVE_CONFLICT( { state } ) {
    const params = { headers: { Authorization: `Bearer ${JwtService.getToken()}` } }
    const payload = {
      task: "conflictResolve",
      payload: {
        invalid,
        product_info,
        valid,
      }
    };
    return new Promise((resolve, reject) => {
      axios
        .post(AppUrl, data, params)
        .then(function (response) {
          // console.log(`action - ${payload.task}: `, response.data);
          resolve(response);
        })
        .catch((err) => commit('CATCH_BY_STATUS', err.response.status));
    });
  },
  UPDATE_SELLER_VARIATION({ commit }, data) {
    const params = { headers: { Authorization: `Bearer ${JwtService.getToken()}` } }
    const payload = {
      task: "alterTrackVariation",
      payload: {
        variation_id: data.variation_id,
        track_id: data.track_id
      }
    };
    return new Promise((resolve, reject) => {
      axios
        .post(AppUrl, payload, params)
        .then(function (response) {
          if(!response.data.error) {
            commit('SET_SELLER_VARIATION', data)
            commit('SET_variationSuccessSnackbar', true)
          } else{ // in case the database does not allow us to update
            commit('SET_variationErrorSnackbar', true)
          }
          resolve(response);
        })
        .catch((err) => commit('CATCH_BY_STATUS', err.response.status));
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/production.js